export function getAllWaittingBookingCount(branchList = []) {
  const totalWaitingBookingCount = branchList.reduce((total, branch) => {
    if (!branch.isArchived) return total + +branch.waitingBookingCount;
    return total;
  }, 0);
  // console.log({ totalWaitingBookingCount });
  return totalWaitingBookingCount;
}
